import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../services/api';

export default function usePageTracker() {
  const location = useLocation();
  useEffect(() => {
    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) return;
    api.post('/analytics/track', { path: location.pathname }).catch(() => {});
  }, [location.pathname]);
}
